import { FIELDS } from './constants';

const initialState = {
  [FIELDS.BRANDS]: [],
  [FIELDS.MODELS]: [],
  [FIELDS.VERSIONS]: [],
  [FIELDS.BRANDS_FETCH]: false,
  [FIELDS.MODELS_FETCH]: false,
  [FIELDS.VERSIONS_FETCH]: false,
  [FIELDS.ALL_FETCH]: false,
  [FIELDS.ERROR]: '',
  [FIELDS.SELECTED]: {},
};

export default initialState;
